import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, useText } from "@sveabank/cc-common";
import type React from "react";

type Props = {
	isOpen: boolean;
	onContinueClick: () => void;
	onCancelClick: () => void;
};

const SignWarningModal: React.FC<Props> = ({ isOpen, onCancelClick, onContinueClick }) => {
	const [t, texts] = useText();

	return (
		<Dialog
			isDismissable={false}
			size="small"
			center
			isOpen={isOpen}
			heading={t(texts.error.modal.openLockedStep.title)}
			icon="error"
		>
			<Dialog.Content>{t(texts.error.modal.openLockedStep.body)}</Dialog.Content>
			<ButtonGroup>
				<Button onPress={onContinueClick}>{t(texts.error.modal.openLockedStep.continue)}</Button>
				<Button onPress={onCancelClick} variant="secondary">
					{t(texts.error.modal.openLockedStep.abort)}
				</Button>
			</ButtonGroup>
		</Dialog>
	);
};

export default SignWarningModal;
